import React from "react";
import {
  RadialBarChart,
  RadialBar,
  ResponsiveContainer,
} from "recharts";

/**
 * RadialProgress — Circular progress ring built on recharts.
 *
 * Props:
 *   value       — 0-100 percentage
 *   size        — Width/height in px (default 120)
 *   color       — Fill color hex (default #2563eb)
 *   trackColor  — Background track color
 *   label       — Text below percentage
 *   className   — Extra class
 */
const RadialProgress = ({
  value = 0,
  size = 120,
  color = "#2563eb",
  trackColor = "var(--bg-hover, #f3f4f6)",
  label,
  className = "",
}) => {
  const data = [{ value: Math.min(Math.max(value, 0), 100), fill: color }];

  return (
    <div className={`ui-radial ${className}`}>
      <ResponsiveContainer>
        <RadialBarChart
          innerRadius="70%"
          outerRadius="100%"
          data={data}
          startAngle={90}
          endAngle={-270}
        >
          <RadialBar
            background={{ fill: trackColor }}
            dataKey="value"
            cornerRadius={10}
          />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="ui-radial__center">
        <span className="ui-radial__value">{value}%</span>
        {label && <span className="ui-radial__label">{label}</span>}
      </div>
    </div>
  );
};

export default RadialProgress;
